var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconAward(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 35,
    viewBox: "0 0 35 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.8672 14.1649C10.8672 15.9236 11.5659 17.6104 12.8095 18.854C14.0531 20.0976 15.7399 20.7963 17.4986 20.7963C19.2574 20.7963 20.9442 20.0976 22.1878 18.854C23.4314 17.6104 24.1301 15.9236 24.1301 14.1649C24.1301 12.4061 23.4314 10.7193 22.1878 9.47571C20.9442 8.23207 19.2574 7.5334 17.4986 7.5334C15.7399 7.5334 14.0531 8.23207 12.8095 9.47571C11.5659 10.7193 10.8672 12.4061 10.8672 14.1649Z",
    stroke: "#151515",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.499 20.7963L21.2568 27.3062L23.023 23.7329L26.9996 23.9893L23.2418 17.4806M11.7539 17.4806L7.99609 23.9905L11.9728 23.7329L13.7389 27.3051L17.4968 20.7963",
    stroke: "#151515",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconAward);
export default __webpack_public_path__ + "static/media/icon_award.e7d7c67fee8ab71e3fd80cd6daa41cba.svg";
export { ForwardRef as ReactComponent };